import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ViewHeaderPage } from "./../view-header/view-header";
import { ShopperSocialGroupCreateShopNewPage } from "./../shopper-social-group-create-shop-new/shopper-social-group-create-shop-new";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-shopper-social-group-create-shop",
  templateUrl: "shopper-social-group-create-shop.html",
})
export class ShopperSocialGroupCreateShopPage {
  spaces: any = [1];
  plaza_id: any;
  plaza = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {
    this.plaza_id = this.navParams.data.plaza_id;
    if (this.plaza_id == 1) {
      this.plaza = "A";
    } else if (this.plaza_id == 2) {
      this.plaza = "B";
    } else if (this.plaza_id == 3) {
      this.plaza = "C";
    } else if (this.plaza_id == 4) {
      this.plaza = "D";
    } else if (this.plaza_id == 5) {
      this.plaza = "E";
    } else if (this.plaza_id == 6) {
      this.plaza = "F";
    } else {
      this.plaza = this.plaza_id;
    }
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log('ionViewDidLoad ShopperSocialGroupCreateShopPage');
  }

  createGroup() {
    this.navCtrl.push(ShopperSocialGroupCreateShopNewPage, {
      plaza_id: this.plaza_id,
    });
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-create-shop/shopper-social-group-create-shop.ts